import { Permissions, security } from "Common/permissions";
import { PageObject, ROUTE_ANCHOR, registerRouting } from "Common/routingUtils";
import hashes from "./routesMap.hash";
import locale from "./routesMap.locale";
import routingKeys from "./routingKeys";
import SummaryReportDetailsPage from "./summaryReportDetails";
if (security.isAllowed([Permissions.SummaryReportsView])) {
    registerRouting(routingKeys.SUMMARY_REPORT_DETAILS, new PageObject(SummaryReportDetailsPage, {
        hash: `${hashes.SUMMARY_REPORT_DETAILS}/(?<summaryReportId>(?!0+$)\\d+)`,
        locale: locale.SUMMARY_REPORT_DETAILS
    }, null, false, (summaryReportId) => {
        if (!Number.isFinite(Number(summaryReportId)) || summaryReportId <= 0)
            return null;
        return `${ROUTE_ANCHOR}${hashes.SUMMARY_REPORT_DETAILS}/${summaryReportId}`;
    }));
}
